import React from 'react'
import { string, func } from 'prop-types'
import styled from 'styled-components'
import { rem } from 'polished'

import { Button } from '../../Button'

const StyledButton = styled(Button)(
  ({ theme }) => `
    background-color: ${theme.isDark ? theme.grey : theme.white};
    border: 1px solid ${theme.isDark ? theme.darkGrey : theme.medLightGrey};
    color: ${theme.textColor};
    & > div > span {
      display: flex;
      width: 100%;
      align-items: center;
    }
`
)

const StyledIcon = styled.svg`
  padding: ${rem(13)} ${rem(20)};
`

const StyledTextWrapper = styled.div`
  vertical-align: middle;
  font-size: ${rem(14)};
  font-weight: bold;
  line-height: ${rem(12)};
  padding: ${rem(19)} 0;
`
export default function SocialButton({ link, openChild, icon, text }) {
  return (
    <StyledButton
      forwardedAs={openChild ? 'button' : 'a'}
      onClick={() => {
        openChild ? openChild(link) : null
      }}
      href={link}
    >
      <StyledIcon as={icon} width={24} height={24} stroke='none' />
      <StyledTextWrapper>
        <div>{text}</div>
      </StyledTextWrapper>
    </StyledButton>
  )
}

SocialButton.propTypes = {
  icon: func,
  link: string,
  text: string,
  openChild: func,
}

SocialButton.defaultProps = {
  link: '#',
}
